module.exports = __webpack_public_path__ + "img/RFishingBoat64_ua.713f6c99.webp";